var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "instagram_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7499"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18862"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18712"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#instagram_svg__a)",
  "data-name": "Group 18711"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.31 14.4a1.191 1.191 0 1 0 1.19 1.19 1.19 1.19 0 0 0-1.19-1.19",
  "data-name": "Path 27255"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.014 24.137a3.205 3.205 0 1 1 3.2-3.206 3.21 3.21 0 0 1-3.2 3.206m0-8.21a5 5 0 1 0 5 5 5.01 5.01 0 0 0-5-5",
  "data-name": "Path 27256"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.874 12.682a4.2 4.2 0 0 0-4.192 4.192v8.113a4.2 4.2 0 0 0 4.192 4.192h8.113a4.2 4.2 0 0 0 4.192-4.192v-8.113a4.2 4.2 0 0 0-4.192-4.192Zm8.113 18.409h-8.113a6.11 6.11 0 0 1-6.1-6.1v-8.117a6.11 6.11 0 0 1 6.1-6.1h8.113a6.11 6.11 0 0 1 6.1 6.1v8.113a6.11 6.11 0 0 1-6.1 6.1",
  "data-name": "Path 27257"
}))))));
export { SvgInstagram as ReactComponent };
export default __webpack_public_path__ + "static/media/instagram.6fa004338aa2d042993ad18586718b78.svg";